import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Row, Col } from 'react-flexbox-grid';
import { Link } from 'react-router';

import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';

import { PunctuationAlert, TermsLabel } from '../../common/partials';
import { gendersT, onboardingSteps } from '../../../../common/enums';
import rules from '../../../../common/rules/rules';
import accountRules from '../../../../common/rules/accountRules';
import { rcFieldDecoratorOptions, createRcBackspaceHandler } from '../../../../common/utils/rcMask';
import authApi from '../../../auth/api';
import Cookies from 'js-cookie';

const FormItem = Form.Item;

const spanStyle = {
  color: '#ED4F2E',
  display: 'none',
};

let doSubmit = false;

@Form.create()
@translate()
export default class StepForm1 extends Component {
  static propTypes = {
    accountData: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    saveAndGoToStep: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = {
    emailInUse: false
  };

  handleBothMethods = e => {
    e.target.value = e.target.value.split(" ").join("").toUpperCase();
    this.onBlurSaveLoanData(e);
  };

  handleSubmit = e => {
    if (e.preventDefault) e.preventDefault();
    doSubmit = false;

    const { form, saveAndGoToStep } = this.props;
    const element = this.refs.notValidText;

    form.validateFields((err, formData) => {
      if (!err) {
        authApi.checkIfExists({ email: formData.email, personalNumber: formData.personalNumber, phone: formData.phone, iban: formData.iban }).then(resp => {
          if (resp.ok && !resp.data.exists) {
            this.props.form.nextPage = "yes";
            this.handleSaveLoanCreationAttempt();
            saveAndGoToStep(onboardingSteps[1], formData);
          } else {
            element.style.display = "inline";
          }
        });

      }
    });
  };


  handleEmptySpacesBlur = e => {
    e.target.value = e.target.value.split(" ").join("");
  }

  handleUpperCaseFirst = e => {
    e.target.value = e.target.value.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  submitWasIssued() {
    doSubmit = true;
  }

  onBlurSaveLoanData = e => {
    this.handleSaveLoanCreationAttempt();
    if (doSubmit) {
      this.handleSubmit(e);
    }
  }

  async handleSaveLoanCreationAttempt() {
    this.props.updateLoanCreationAttempt({ cookieId: Cookies.get('id'), form: this.props.form, step: 1 });
  }

  handleNameBlur = name => e => {
    this.props.form.setFieldsValue({ [name]: e.target.value.replace(/\s+/g, ' ').trim() });
    this.onBlurSaveLoanData(e);
  }

  render() {
    const { accountData, form, t } = this.props;
    const { getFieldDecorator } = form;

    return (
      <section className="onboarding-form">
        <h2 className="section-title">{t('Osobné údaje')}</h2>
        <PunctuationAlert />
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem label={t('Krstné meno')}>
                {getFieldDecorator('nameFirst', {
                  rules: rules.required,
                  initialValue: accountData.nameFirst,
                })(<Input size="default" placeholder={t('Krstné meno')} autoFocus
                  onChange={this.handleUpperCaseFirst}
                  onBlur={this.handleNameBlur('nameFirst')}
                />)}
              </FormItem>
            </Col>
            <Col xs={12} sm={6}>
              <FormItem label={t('Priezvisko')}>
                {getFieldDecorator('nameLast', {
                  rules: rules.required,
                  initialValue: accountData.nameLast,
                })(<Input size="default" placeholder={t('Priezvisko')} onChange={this.handleUpperCaseFirst} onBlur={this.handleNameBlur('nameLast')} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem label={t('Rodné priezvisko')}>
                {getFieldDecorator('birthLastName', {
                  rules: [],
                  initialValue: accountData.birthLastName,
                })(<Input size="default" placeholder={t('Rodné priezvisko')} onChange={this.handleUpperCaseFirst} onBlur={this.handleNameBlur('birthLastName')} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem label={t('Pohlavie')}>
                {getFieldDecorator('gender', {
                  rules: rules.required,
                  initialValue: accountData.gender,
                })(
                  <Select size="default" placeholder={t('Pohlavie')} onBlur={this.onBlurSaveLoanData}>
                    {Object.entries(gendersT).map(([key, value]) => (
                      <Select.Option value={key} key={key}>
                        {value}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col xs={12} sm={6}>
              <FormItem label={t('Rodné číslo')}>
                {getFieldDecorator('personalNumber', {
                  rules: [
                    ...accountRules.personalNumber,
                    {
                      validator: accountRules.checkValidPersonalNumber(form),
                    },
                  ],
                  validateFirst: true,
                  initialValue: accountData.personalNumber,
                  validateTrigger: 'onBlur',
                  ...rcFieldDecoratorOptions,
                })(<Input size="default" placeholder={t('rrmmddxxxx')} onBlur={this.onBlurSaveLoanData} onKeyDown={createRcBackspaceHandler(form, 'personalNumber')} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <FormItem label={t('E-mail')}>
                {getFieldDecorator('email', {
                  rules: accountRules.email,
                  initialValue: accountData.email,
                  validateTrigger: 'onBlur',
                })(<Input size="default" placeholder={t('E-mail')} type="email" />)}
              </FormItem>

            </Col>
          </Row>
          <Row>
            <Col xs>
              <FormItem label={t('Telefónne číslo')}>
                {getFieldDecorator('phone', {
                  rules: accountRules.telephoneNumber,
                  initialValue: accountData.phone,
                  validateTrigger: 'onBlur',
                })(<Input size="default" placeholder={t('090x xxx xxx')} onChange={this.handleEmptySpacesBlur} onBlur={this.onBlurSaveLoanData} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <FormItem label={t('IBAN')}>
                {getFieldDecorator('iban', {
                  rules: accountRules.iban,
                  initialValue: accountData.iban,
                  validateTrigger: 'onBlur',
                })(<Input size="default" placeholder={t('IBAN')} onBlur={this.handleBothMethods} onChange={this.handleBothMethods} />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <FormItem>
                {getFieldDecorator('terms', {
                  rules: rules.radioAgreement,
                  initialValue: accountData.terms,
                })(
                  <div className="terms-wrapper">
                    <Checkbox defaultChecked={true} />
                    <TermsLabel />
                  </div>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row center="xs" className="form-actions-row">
            <Col xs={12} sm={6}>
              <span ref="notValidText" style={spanStyle}>Niektoré z Vašich údajov už boli v minulosti použité. Ak ste klientom, <a href="#/auth/login">prihláste sa</a>. Ak ste nikdy neboli klientom, prosím kontaktujte nás.</span>
              <Button type="primary" size="large" htmlType="submit" className="btn-block" onMouseDown={this.submitWasIssued}>
                {t('Pokračovať')}
              </Button>
            </Col>
          </Row>
        </Form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/components/debtor/StepForm1.js